import React from "react";
import Icons from "./../../../utils/import.icons";

interface Props {
    isProyecto: boolean;
    isSidebarHidden: boolean;
    proyecto: any;
    secondaryBtnSelected: any;
    handleShowProyecto: any;
}

interface State { }

interface Info {
    Icons?: any;
}

class ProyectoSidebar extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    render(): React.ReactNode {
        const ameniadesIcons: Info = { Icons };
        return (
            <div>
                <div className="">
            <a href={require("../../../UI/2022-07-22_PANORAMIK 1_PRESENTACION COMERCIAL.pdf")} target="_blank"></a>
          </div>
            </div>
        );
    }
}

export default ProyectoSidebar;